import styled from "styled-components";

export const PressContactCardWrapper = styled.div`
  display: grid;
  background-color: rgba(13, 65, 121, 0.7);
  padding: 15px;
  text-align: center;
  border-top: 8px solid #00aeef;
`